import { render } from "./DefaultListSubSectionNewsV2Cmp.vue?vue&type=template&id=48e0ab3e"
import script from "./DefaultListSubSectionNewsV2Cmp.vue?vue&type=script&lang=js"
export * from "./DefaultListSubSectionNewsV2Cmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__